// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgeCheckController from "./age_check_controller"
application.register("age-check", AgeCheckController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HomeTabsController from "./home_tabs_controller"
application.register("home-tabs", HomeTabsController)

import MediaGalleryController from "./media_gallery_controller"
application.register("media-gallery", MediaGalleryController)

import NavSearchController from "./nav_search_controller"
application.register("nav-search", NavSearchController)

import HeroSearchController from "./hero_search_controller"
application.register("hero-search", HeroSearchController)

import CasinoFilterController from "./casino_filter_controller"
application.register("casino-filter", CasinoFilterController)

import SortDropdownController from "./sort_dropdown_controller"
application.register("sort-dropdown", SortDropdownController)

import RagSidebarController from "./rag_sidebar_controller"
application.register("rag-sidebar", RagSidebarController)
